const prefix = '@retailMedia/grocery/configuration'

export const MIN_COSTS = `${prefix}/MIN_COSTS`

export const types = {
  minCosts: MIN_COSTS
}
